// packages import
import { Box, Button, CircularProgress, DialogActions, Typography } from "@mui/material"
import { FC, useContext } from "react"
// component import
import { Alert } from "../../common/Alert"
import { CustomModal } from "../../common/CustomModal"
// others
import { useDeleteNoteMutation } from "../../../../generated"
import { CANCEL } from "../../../constants"
import { CaseContext } from "../../../context"
import { DeleteNoteModalProps, ErrorException } from "../../../interfaceTypes"
import { titleize } from "../../../utils"
import { CaseActionType } from "../../cases/caseReducer"

export const DeleteNote: FC<DeleteNoteModalProps> = ({ refetchAllNotes, refetchCase }) => {
  const { isNoteDeleteOpen, currentNote, dispatch } = useContext(CaseContext)
  const { id, description } = currentNote || {}

  const handleClose = () => {
    dispatch({ type: CaseActionType.SET_IS_NOTE_DELETE_OPEN, isNoteDeleteOpen: false })
  }

  const [deleteNote, { loading }] = useDeleteNoteMutation({
    onError(error) {
      const { graphQLErrors } = error

      if (graphQLErrors) {
        graphQLErrors.map(
          // eslint-disable-next-line
          ({ extensions }) => {
            if (extensions) {
              const { exception } = extensions;
              if (exception) {
                const { response } = exception as ErrorException
                const { response: errorResponse } = response || {}
                if (errorResponse) {
                  const { error } = errorResponse
                  Alert.error(error)
                }
              }
            }
          })
      }
    },

    onCompleted(data) {
      if (data) {
        const { deleteNote } = data
        const { response } = deleteNote || {}
        const { status } = response || {}

        if (status === 200) {
          refetchAllNotes && refetchAllNotes()
          Alert.success('Note deleted successfully')
          refetchCase && refetchCase();
          dispatch({ type: CaseActionType.SET_IS_NOTE_DELETE_OPEN, isNoteDeleteOpen: false })
        }
      }
    }
  })

  const handleDelete = async () => {
    if (id) {
      await deleteNote({
        variables: {
          deleteNoteInput: {
            id
          }
        }
      });
    }
  }

  return (
    <CustomModal title="Delete note" isOpen={isNoteDeleteOpen} handleClose={handleClose}>
      <Typography variant="body1">You are about to delete the following Note:</Typography>

      <Box mt={1}>
        <Typography>{titleize(description || '')}</Typography>
      </Box>

      <DialogActions sx={{ padding: '30px 0 0', flexWrap: 'wrap', }}>
        <Button onClick={handleClose} variant='outlined' aria-label={CANCEL}>{CANCEL}</Button>

        <Button
          disabled={loading}
          onClick={handleDelete} color='primary' variant="contained"
          endIcon={loading && <CircularProgress size={20} color="inherit" />}
          aria-label='delete note'
        >
          Delete note
        </Button>
      </DialogActions>
    </CustomModal>
  )
}